import {
  SCRIPT_GENERATION_DATASET as SHARED_SCRIPT_GENERATION_DATASET,
  SCRIPT_GENERATION_DATASETS as SHARED_SCRIPT_GENERATION_DATASETS,
} from "@nexus/contracts"

/** Dataset names eligible for script generation. */
export const SCRIPT_GENERATION_DATASETS = new Set(SHARED_SCRIPT_GENERATION_DATASETS)

/** Dataset the script-generation gate dialog suggests switching to. */
export const SCRIPT_GENERATION_DATASET = SHARED_SCRIPT_GENERATION_DATASET

export function isScriptGenerationEligible(dataset: string): boolean {
  return SCRIPT_GENERATION_DATASETS.has(dataset)
}

export interface ScriptGenerationSelectionPartition {
  eligibleIds: string[]
  ineligibleIds: string[]
  /** Distinct non-eligible dataset names among ineligible rows. */
  ineligibleDatasets: string[]
  /** Selected IDs not present in the loaded opportunity list (e.g. not yet fetched). */
  unknownIds: string[]
}

export function partitionScriptGenerationSelection(
  opportunities: ReadonlyArray<{ id: string; dataset: string }>,
  selectedIds: readonly string[],
): ScriptGenerationSelectionPartition {
  const byId = new Map(opportunities.map((o) => [o.id, o]))
  const eligibleIds: string[] = []
  const ineligibleIds: string[] = []
  const ineligible = new Set<string>()
  const unknownIds: string[] = []

  for (const id of selectedIds) {
    const opp = byId.get(id)
    if (!opp) {
      unknownIds.push(id)
      continue
    }
    if (isScriptGenerationEligible(opp.dataset)) {
      eligibleIds.push(id)
    } else {
      ineligibleIds.push(id)
      ineligible.add(opp.dataset)
    }
  }

  return {
    eligibleIds,
    ineligibleIds,
    ineligibleDatasets: [...ineligible],
    unknownIds,
  }
}

/** When the table is filtered to an eligible dataset, every loaded row is eligible. */
export function isScriptGenerationFilterActive(dataset: string): boolean {
  return SCRIPT_GENERATION_DATASETS.has(dataset)
}
